import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import GatherGuard from "../../../Assets/Images/L_Intact_ins_Horiz_Entertainment_rgb.svg";
import { useReactable } from "@reactables/react";
import { RxToggle } from "@jauntin/reactables";
import { Modal } from "react-bootstrap";
import SidebarItems from "./SidebarItems";

const Header = ({ referralParams }: { referralParams?: string }) => {
  const [
    showMobileMenu,
    { toggle: toggleMobileMenu, toggleOff: hideMobileMenu },
  ] = useReactable(RxToggle);
  const lgBreakpoint = 1200;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= lgBreakpoint) {
        hideMobileMenu();
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [hideMobileMenu, lgBreakpoint]);

  return (
    <header className="header">
      <div className="container h-100">
        <div className="form-row h-100 align-items-center justify-content-between">
          <div className="col col-sm-auto">
            <Link to="/">
              <img
                width="175"
                height="36"
                src={GatherGuard}
                alt="Logo"
                className="img-fluid logo__img"
              />
            </Link>
          </div>
          <div className="col-auto gatherguard">GatherGuard</div>
          <div className="col-auto text-right d-none d-sm-none d-md-block">
            <div className="header__help-text">
              For&nbsp;assistance, please&nbsp;call
            </div>
            <a href="tel:+1-844-747-6240" className="header__help-num">
              (844) 747-6240
            </a>
          </div>
          <div className="col-auto d-block d-sm-block d-md-block d-lg-block d-xl-none">
            <button
              className="header__toggle-mobile-menu"
              onClick={toggleMobileMenu}
            >
              {showMobileMenu ? (
                <i className="fal fa-light fa-times"></i>
              ) : (
                <i className="fal fa-light fa-bars"></i>
              )}
            </button>
          </div>
        </div>
      </div>
      <Modal
        dialogClassName="header__dialog"
        show={showMobileMenu}
        onHide={toggleMobileMenu}
      >
        <SidebarItems referralParams={referralParams} />
      </Modal>
    </header>
  );
};

export default Header;
